import { usePathname } from 'next/navigation'

import { useEffect, useState } from 'react'

interface UseElementInViewOptions {
  threshold?: number
  rootMargin?: string
}

export const useElementInView = (elementId: string, options: UseElementInViewOptions = {}) => {
  const [isInView, setIsInView] = useState(true)
  const pathname = usePathname()

  useEffect(() => {
    // Reset view state when pathname changes
    setIsInView(true)

    // Use setTimeout to allow the DOM to update after navigation
    const timerId = setTimeout(() => {
      const element = document.getElementById(elementId)
      if (!element) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsInView(entry.isIntersecting)
        },
        {
          rootMargin: options.rootMargin,
          threshold: options.threshold ?? 0.5,
        },
      )

      observer.observe(element)

      return () => {
        observer.disconnect()
      }
    }, 0) // Run after current render cycle

    return () => {
      clearTimeout(timerId)
    }
  }, [elementId, options.threshold, options.rootMargin, pathname])

  return isInView
}
